// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@5.2.7_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".swiper[data-v-6ac9f623]{overflow:visible}.swiper-wrapper[data-v-6ac9f623]{height:-moz-fit-content;height:fit-content;width:-moz-fit-content;width:fit-content}.swiper-slide[data-v-6ac9f623]{height:auto}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
